import React from 'react';
import { Button } from 'react-admin';
import PrintIcon from '../../../components/shared/icons/PrintIcon';
import { getPumpCurvesPdf } from '../../../core/services/pump-api.service';
import { downloadFile } from '../../../core/utils/file-utils';
import { EXPORT_PDF_DATA } from '../../../core/constants/file.constants';

interface Props {
  pumpId: string;
  pumpName: string;
  disabled?: boolean;
  speedIds?: string[];
}

export const PumpCurvesDownloadPdfButton = (props: Props) => {
  const { pumpId, pumpName, disabled = false, speedIds } = props;

  const handle = async () => {
    const response = await getPumpCurvesPdf(pumpId, speedIds);

    const base64Response = await fetch(
      `${EXPORT_PDF_DATA},${response.data.file}`
    );
    const blob = await base64Response.blob();
    downloadFile(blob, `${pumpName.replace(/\s+/g, '_')}_curves.pdf`);
  };

  return (
    <Button
      startIcon={<PrintIcon />}
      variant="outlined"
      size="medium"
      label={'resources.pumps.curves.downloadPdf'}
      disabled={disabled}
      onClick={handle}
    />
  );
};
